import { Badge, Card, Group, Stack, Text } from "@mantine/core";
import { Link } from "wouter";
import {
  articleCountsLabel,
  clusterResearchStatus,
  editionLabel,
  usableEditions,
} from "./clusterDisplay";

export default function ClusterCard({ cluster, planName }) {
  const href = `/plans/${cluster.planId}/clusters/${cluster.id}`;
  const researchStatus = clusterResearchStatus(cluster);
  const editions = usableEditions(cluster.editions);

  return (
    <Card
      component={Link}
      href={href}
      shadow="sm"
      padding="lg"
      radius="md"
      withBorder
      style={{ cursor: "pointer" }}
    >
      <Stack gap="sm">
        <Group justify="space-between" align="flex-start" wrap="nowrap">
          <div>
            <Text size="lg" fw={600} lineClamp={2}>
              {cluster.title}
            </Text>
            {planName && (
              <Text size="xs" c="dimmed" mt={4}>
                {planName}
              </Text>
            )}
          </div>
          <Badge
            color={
              researchStatus === "ready"
                ? "teal"
                : researchStatus === "running"
                  ? "blue"
                  : "orange"
            }
            variant="light"
            style={{ flexShrink: 0 }}
          >
            {researchStatus === "ready"
              ? "Researched"
              : researchStatus === "running"
                ? "Researching"
                : "Not researched"}
          </Badge>
        </Group>

        {cluster.goal && (
          <Text size="sm" c="dimmed" lineClamp={2}>
            {cluster.goal}
          </Text>
        )}

        <Group gap="xs">
          {editions.length > 0
            ? editions.map((e) => (
                <Badge key={e.id || editionLabel(e)} variant="outline" color="grape">
                  {editionLabel(e) || "Market"}
                </Badge>
              ))
            : (
              <Text size="xs" c="dimmed">
                No market researched yet
              </Text>
            )}
        </Group>

        {researchStatus === "ready" && (
          <Text size="sm">{articleCountsLabel(cluster)}</Text>
        )}
      </Stack>
    </Card>
  );
}
